<script>

	import axios from 'axios'
	import { required, email } from 'vuelidate/lib/validators'
	import Fragment from '@/components/Fragment'
	import Form from '@/components/Form'

	const lambdaApi = axios.create({
		baseURL: 'https://w2ctsuk8z3.execute-api.us-east-1.amazonaws.com/production/v1'
	})

	export default {
		data () {
			return {
				formData: {
					product: null,
					firstName: null,
					lastName: null,
					email: null,
					phoneNumber: null,
					jobTitle: null,
					company: null,
					city: null,
					stateAbbrev: null,
					country: 'US'
				}
			}
		},

		computed: {
			schema () {
				return {
					product: { required },
					firstName: { required },
					lastName: { required },
					email: { required, email },
					phoneNumber: { required },
					jobTitle: { required },
					company: { required },
					city: { required },
					stateAbbrev: { required },
					country: { required }
				}
			}
		},

		methods: {
			async submitRequest (form) {
				await lambdaApi.post('free-trial', {
					lead: form.formData
				})
			}
		},

		render () {
			return (
				<Form schema={this.schema} formData={this.formData} onSubmit={this.submitRequest}>
					{({ success }) => (
						success ? (
							<div class="thankyou">
								<h2>Thank you!</h2>
								<p>Thank you for your interest in StudySync. You will soon receive an email with log-in credentials for your free trial.</p>
								<p>If you do not see the email in your inbox, please be sure to check your spam folder or email us at info@studysync.com.</p>
							</div>
						) : (
							<Fragment>
								<Form.Select
									prop="product"
									label="Product"
									options={[
										{ value: '', label: 'Select a product' },
										{ value: 'ELA', label: 'StudySync ELA Trial' },
										{ value: 'ELA_GLOBAL', label: 'StudySync Global ELA Trial' },
										{ value: 'SB_SOCIAL_STUDIES', label: 'SyncBlasts Social Studies Trial' },
										{ value: 'SB_SCIENCE', label: 'SyncBlasts Science Trial' }
									]}
								/>
								<div class="form__group">
									<Form.Input
										prop="firstName"
										label="First Name"
									/>
									<Form.Input
										prop="lastName"
										label="Last Name"
									/>
								</div>
								<div class="form__group">
									<Form.Input
										type="email"
										prop="email"
										label="Email Address"
										errorMessage={() => `A valid email address is required.`}
									/>
									<Form.Input
										prop="phoneNumber"
										label="Phone Number"
									/>
								</div>
								<div class="form__group">
									<Form.Select
										prop="jobTitle"
										label="Job Title"
										options={[
											{ value: '', label: 'Select a job title' },
											{ value: 'TEACHER', label: 'Teacher' },
											{ value: 'TEACHER_SUPPORT', label: 'Teacher Support' },
											{ value: 'PRINCIPAL', label: 'Principal' },
											{ value: 'ASSISTANT_PRINCIPAL', label: 'Assistant Principal' },
											{ value: 'TECHNOLOGY', label: 'Technology' }
										]}
									/>
									<Form.Input
										prop="company"
										label="School/Company"
									/>
								</div>
								<div class="form__group">
									<Form.Input
										prop="city"
										label="City"
									/>
									<Form.Select.USStates
										prop="stateAbbrev"
										label="State"
									/>
								</div>
								<Form.Select.Countries
									prop="country"
									label="Country"
								/>
							</Fragment>
						)
					)}
				</Form>
			)
		}
	}

</script>



// WEBPACK FOOTER //
// src/components/FreeTrialForm.vue